import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card shadow-sm" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = {
  id: "kt_profile_change_password",
  class: "card-body"
}
const _hoisted_5 = ["validation-schema"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = { class: "required mb-3" }
const _hoisted_10 = { class: "position-relative" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "mb-5" }
const _hoisted_14 = { class: "required mb-3" }
const _hoisted_15 = { class: "position-relative" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "mb-5" }
const _hoisted_19 = { class: "required mb-3" }
const _hoisted_20 = { class: "position-relative" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "d-flex gap-5 flex-end mt-10" }
const _hoisted_24 = { class: "indicator-label" }
const _hoisted_25 = { class: "indicator-progress" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { ref } from "vue";
import * as Yup from "yup";
import { Field, ErrorMessage, useForm } from "vee-validate";
import { axiosInstance as axios } from "@/core/services/api.client";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordSetting',
  setup(__props) {

const eyeClick = ref(false);
const { t } = i18n.global;

const newPassword = ref("");
const currentPassword = ref("");
const submitButtonRef = ref<null | HTMLButtonElement>(null);

const validationSchema = Yup.object().shape({
  oldPassword: Yup.string().required().label("Old Password"),
  newPassword: Yup.string()
    .min(8, t("error.signup_ps_8"))
    .matches(/[a-z]/, t("error.signup_ps_lower"))
    .matches(/[A-Z]/, t("error.signup_ps_upper"))
    .matches(/\d/, t("error.signup_ps_number"))
    .matches(/[!@#$%^&*(),.?":{}|<>]/, t("error.signup_ps_symbol"))
    .required(t("error.signup_ps_require")),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("newPassword"), null],
    t("error.signup_ps_match")
  ),
});

const { handleSubmit, resetForm } = useForm({
  validationSchema,
});

const onResetPassword = handleSubmit(async () => {
  if (!submitButtonRef.value) {
    return;
  }

  submitButtonRef.value.disabled = true;
  submitButtonRef.value.setAttribute("data-kt-indicator", "on");

  try {
    await axios.post("/api/v1/auth/password/change", {
      currentPassword: currentPassword.value,
      newPassword: newPassword.value,
    });
    MsgPrompt.success(t("tip.passwordResetSuccess")).then(() => {
      resetForm();
    });
  } catch (error) {
    MsgPrompt.error(error);
  }

  submitButtonRef.value.disabled = false;
  submitButtonRef.value.setAttribute("data-kt-indicator", "off");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("action.changePassword")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", {
        id: "kt_profile_change_password_form",
        class: "form",
        "validation-schema": _unref(validationSchema),
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onResetPassword) && _unref(onResetPassword)(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("fields.oldPwd")), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(Field), {
                  type: eyeClick.value ? 'text' : 'password',
                  name: "oldPassword",
                  class: "form-control form-control-solid",
                  modelValue: currentPassword.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event))
                }, null, 8, ["type", "modelValue"]),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid fa-lg cursor-pointer position-absolute", eyeClick.value ? 'fa-eye-slash' : 'fa-eye']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (eyeClick.value = !eyeClick.value)),
                  style: {"top":"50%","right":"15px","transform":"translateY(-50%)"}
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(ErrorMessage), { name: "oldPassword" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("fields.newPwd")), 1),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_unref(Field), {
                  modelValue: newPassword.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPassword).value = $event)),
                  name: "newPassword",
                  type: eyeClick.value ? 'text' : 'password',
                  class: "form-control form-control-solid"
                }, null, 8, ["modelValue", "type"]),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid fa-lg cursor-pointer position-absolute", eyeClick.value ? 'fa-eye-slash' : 'fa-eye']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (eyeClick.value = !eyeClick.value)),
                  style: {"top":"50%","right":"15px","transform":"translateY(-50%)"}
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(ErrorMessage), { name: "newPassword" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("fields.newPwd")), 1),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_unref(Field), {
                  type: eyeClick.value ? 'text' : 'password',
                  name: "confirmPassword",
                  class: "form-control form-control-solid"
                }, null, 8, ["type"]),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid fa-lg cursor-pointer position-absolute", eyeClick.value ? 'fa-eye-slash' : 'fa-eye']),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (eyeClick.value = !eyeClick.value)),
                  style: {"top":"50%","right":"15px","transform":"translateY(-50%)"}
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(ErrorMessage), { name: "confirmPassword" })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-secondary",
            type: "reset",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(resetForm)()))
          }, _toDisplayString(_ctx.$t("action.reset")), 1),
          _createElementVNode("button", {
            ref_key: "submitButtonRef",
            ref: submitButtonRef,
            class: "btn btn-sm btn-primary",
            type: "submit"
          }, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("action.saveChanges")), 1),
            _createElementVNode("span", _hoisted_25, [
              _createTextVNode(_toDisplayString(_ctx.$t("action.pleaseWait")) + " ", 1),
              _hoisted_26
            ])
          ], 512)
        ])
      ], 40, _hoisted_5)
    ])
  ]))
}
}

})